import { getAuctionStatuses, getAuctionTypes } from 'utils/auctions-helper';
import {
  API_REQUEST,
  ACTIVE_AUCTIONS_FETCH_LISTINGS,
  ACTIVE_AUCTIONS_FETCH_AUCTIONS,
  FETCH_PUBLIC_PREVIEW_AUCTIONS,
  FETCH_PUBLIC_ACTIVE_AUCTIONS,
  ACTIVE_AUCTIONS_SEARCH_DICTIONARIES,
  ACTIVE_AUCTIONS_PUBLIC_FETCH_LISTINGS,
  AUCTIONS_JEWEL_LISTING_UPDATE_FILTER,
  ACTIVE_AUCTIONS_CHANGE_TABS,
  FETCH_PUBLIC_PREVIEW_LISTINGS,
  AUCTIONS_FETCH_JEWEL_LISTING
} from 'constants/action-types';
import { objToParams } from 'utils/serializers';
import { defaultCatalogSortBy, defaultSortBy, LISTING_STATUSES } from 'constants/listings';
import { defaultFilters } from './reducer';

const defaulSortValue = isCatalog => {
  return isCatalog ? defaultCatalogSortBy : defaultSortBy;
};

export function fetchSearchDictionaries({
  auctionId,
  onlyMyListings = false,
  onlyMyBids = false,
  isAuth = false,
  // onlyInPreview = false,
  isClosed = false
}) {
  let url = '';
  const listingStatus = !onlyMyListings || !onlyMyBids || isClosed ? '' : 'Active';

  if (isAuth) {
    url = `/Jewelry/SearchDictionaries?AuctionId=${auctionId}&OnlyMyListings=${onlyMyListings}&OnlyMyBids=${onlyMyBids}&listingStatus=${listingStatus}`;
  } else {
    url = `/public/listings/preview/searchdictionaries?AuctionId=${auctionId}`;
  }
  return {
    type: API_REQUEST,
    payload: {
      url,
      method: 'get',
      nextActionType: ACTIVE_AUCTIONS_SEARCH_DICTIONARIES
    }
  };
}

export function fetchJewelListing(auctionId, listingId) {
  return {
    type: API_REQUEST,
    payload: {
      url: '/Listings/read',
      method: 'POST',
      data: { auctionId, listingId, pageNumber: 1, pageSize: 1 },
      nextActionType: AUCTIONS_FETCH_JEWEL_LISTING
    }
  };
}

export function fetchPublicActiveListings(data, isCatalog, isFilters) {
  return {
    type: API_REQUEST,
    payload: {
      url: `/public/listings/active`,
      method: 'post',
      data: {
        ...(isFilters ? data : { ...data, ...defaultFilters }),
        status: [LISTING_STATUSES.ACTIVE],
        sortBy:
          data.sortBy.length === 0
            ? defaulSortValue(isCatalog && !data.onlyMyListings)
            : data.sortBy
      },
      nextActionType: ACTIVE_AUCTIONS_PUBLIC_FETCH_LISTINGS,
      additionalActions: !isFilters && [fetchSearchDictionaries({ ...data, isAuth: false })]
    },
    meta: { requestedAuctionId: data.auctionId }
  };
}

export function fetchPublicPreviewListings(data, isCatalog, isFilters) {
  return {
    type: API_REQUEST,
    payload: {
      url: `/public/listings/preview?${objToParams(data)}`,
      method: 'post',
      data: {
        ...(isFilters ? data : { ...data, ...defaultFilters }),
        sortBy:
          data.sortBy.length === 0
            ? defaulSortValue(isCatalog && !data.onlyMyListings)
            : data.sortBy
      },
      nextActionType: FETCH_PUBLIC_PREVIEW_LISTINGS,
      additionalActions: !isFilters && [fetchSearchDictionaries({ ...data, isAuth: false })]
    },
    meta: { requestedAuctionId: data.auctionId }
  };
}

export function fetchActiveListings(data, isCatalog, isFilters) {
  return {
    type: API_REQUEST,
    payload: {
      url: '/Listings/read',
      method: 'POST',
      data: {
        ...(isFilters ? data : { ...defaultFilters, ...data }),
        sortBy:
          data.sortBy.length === 0
            ? defaulSortValue(isCatalog && !data.onlyMyListings)
            : data.sortBy
      },
      nextActionType: ACTIVE_AUCTIONS_FETCH_LISTINGS,
      additionalActions: !isFilters && [fetchSearchDictionaries({ ...data, isAuth: true })]
    },
    meta: { requestedAuctionId: data.auctionId }
  };
}
export function fetchActiveAuctions({
  activeAuction,
  onlyMyBids = false,
  onlyMyListings = false,
  onlyInPreview = false,
  isCatalog = false,
  isCatalogClose = false
}) {
  return {
    type: API_REQUEST,
    payload: {
      url: '/Auctions/read',
      method: 'POST',
      data: {
        pageSize: 100,
        pageNumber: 1,
        onlyMyBids,
        onlyMyListings,
        auctionStatuses: getAuctionStatuses(
          onlyMyBids,
          onlyMyListings,
          onlyInPreview,
          isCatalogClose
        ),
        auctionTypes: getAuctionTypes(onlyMyBids, onlyMyListings, isCatalog)
      },
      nextActionType: ACTIVE_AUCTIONS_FETCH_AUCTIONS
    },
    meta: { activeAuction }
  };
}
export function fetchPublicActiveAuctions({
  activeAuction,
  onlyMyBids = false,
  onlyMyListings = false,
  onlyInPreview = false,
  isCatalog = false
}) {
  return {
    type: API_REQUEST,
    payload: {
      url: '/public/auctions/active',
      method: 'POST',
      data: {
        pageSize: 100,
        pageNumber: 1,
        auctionStatuses: getAuctionStatuses(onlyMyBids, onlyMyListings, onlyInPreview, false),
        auctionTypes: getAuctionTypes(onlyMyBids, onlyMyListings, isCatalog)
      },
      nextActionType: FETCH_PUBLIC_ACTIVE_AUCTIONS
    },
    meta: { activeAuction }
  };
}
export function fetchPublicPreviewAuctions({
  activeAuction,
  onlyMyBids = false,
  onlyMyListings = false,
  onlyInPreview = true,
  isCatalog = false
}) {
  return {
    type: API_REQUEST,
    payload: {
      url: '/public/auctions/preview',
      method: 'POST',
      data: {
        pageSize: 100,
        pageNumber: 1,
        auctionStatuses: getAuctionStatuses(onlyMyBids, onlyMyListings, onlyInPreview, false),
        auctionTypes: getAuctionTypes(onlyMyBids, onlyMyListings, isCatalog)
      },
      nextActionType: FETCH_PUBLIC_PREVIEW_AUCTIONS
    },
    meta: { activeAuction }
  };
}
export function updateFilter(filters) {
  return {
    type: AUCTIONS_JEWEL_LISTING_UPDATE_FILTER,
    payload: filters
  };
}
export function changeTab() {
  return {
    type: ACTIVE_AUCTIONS_CHANGE_TABS,
    payload: defaultFilters
  };
}
